module.exports = __webpack_public_path__ + "static/media/foere-f.fb3aca7d.mp3";